import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import {
  ACTION_GET_CURRENT_COMPANY_INFO,
  ACTION_GET_PROCUREMENT_SUPPLIER_HUBS,
  ACTION_GET_PROCUREMENT_SUPPLIERS,
  DOMAIN_COMPANIES,
  roleGuard,
} from "@api";

export const ACTION_DELETE_PROCUREMENT_SUPPLIER = "DELETE_PROCUREMENT_SUPPLIER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteProcurementSupplier = async (
  procurementSupplierId: string,
): Promise<void> => {
  const response =
    await procurementApi.procurementControllerDeleteProcurementSupplier(
      procurementSupplierId,
    );

  return response.data;
};

export const useDeleteProcurementSupplier = (
  user: UserProfileDto | null,
): {
  deleteProcurementSupplier: (procurementSupplierId: string) => void;
  deleteProcurementSupplierEnabled: boolean;
  isSuccessDeleteProcurementSupplier: boolean;
  isPendingDeleteProcurementSupplier: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_DELETE_PROCUREMENT_SUPPLIER],
    mutationFn: enabled ? deleteProcurementSupplier : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PROCUREMENT, ACTION_GET_PROCUREMENT_SUPPLIERS],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PROCUREMENT, ACTION_GET_PROCUREMENT_SUPPLIER_HUBS],
      });
    },
  });

  return {
    deleteProcurementSupplier: mutate,
    deleteProcurementSupplierEnabled: enabled,
    isSuccessDeleteProcurementSupplier: isSuccess,
    isPendingDeleteProcurementSupplier: isPending,
  };
};
